/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliEnforceCapDto } from '../../models/amoxcalli-enforce-cap-dto';

export interface ApiTeacherInstitutionsByInstitutionInstitutionIdEnforceCapPost$Params {
  institutionId: string;
      body?: AmoxcalliEnforceCapDto
}

export function apiTeacherInstitutionsByInstitutionInstitutionIdEnforceCapPost(http: HttpClient, rootUrl: string, params: ApiTeacherInstitutionsByInstitutionInstitutionIdEnforceCapPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiTeacherInstitutionsByInstitutionInstitutionIdEnforceCapPost.PATH, 'post');
  if (params) {
    rb.path('institutionId', params.institutionId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiTeacherInstitutionsByInstitutionInstitutionIdEnforceCapPost.PATH = '/api/teacher-institutions/by-institution/{institutionId}/enforce-cap';
